import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "button"]

  connect() {
    this.expanded = false
  }

  toggle() {
    this.expanded = !this.expanded

    if (this.expanded) {
      this.contentTarget.classList.remove("line-clamp-5")
      this.buttonTarget.textContent = "Voir moins"
    } else {
      this.contentTarget.classList.add("line-clamp-5")
      this.buttonTarget.textContent = "Voir plus"
    }
  }
}
